/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_RegistrationInputs */



/**
* | output |
* | --- |
* | "Passkey registration failed." |
*
* @param {Passkey_Error_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_registration = /** @type {((inputs?: Passkey_Error_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement de la Passkey a échoué.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El registro del Passkey ha fallado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registro da Passkey falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione della Passkey fallita.")
	return /** @type {LocalizedString} */ ("Passkey registration failed.")
});